import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { useAuth } from 'hooks/useAuth';
import { useSiteConfig } from 'hooks/useSiteConfig';
import { LoadingSpinner } from 'ui/components/LoadingSpinner';

type WithAuthOptions = {
  redirectTo: string;
  from: string;
};

export const withAuth = (Component: React.FC, options?: WithAuthOptions) => {
  const WithUnauthenticatedRedirect = props => {
    const router = useRouter();
    const auth = useAuth();
    const { localizeUrlPath } = useSiteConfig();
    const query = router.asPath.split('?')[1] ?? '';

    useEffect(() => {
      if (auth.guest) {
        router.replace(
          localizeUrlPath(
            `/account/login${query ? `?${query}` : ''}${
              query && options?.from
                ? `&from=${encodeURIComponent(options.from)}`
                : options?.from
                ? `?from=${encodeURIComponent(options.from)}`
                : ''
            }`
          )
        );
      }
    });

    return auth.guest === false ? (
      <Component {...props} />
    ) : (
      <section className="w-full py-48 xl:py-64">
        <LoadingSpinner className="m-auto flex-none w-32 h-32" />
      </section>
    );
  };
  return WithUnauthenticatedRedirect;
};
